(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('Template2Controller', Template2Controller);

    Template2Controller.$inject = ['$state', 'AuthServerProvider', '$stateParams', 'Article', 'StoreWorkEditConfig', 'Product', 'Editors','$localStorage', 'OrderArticle'];

    function Template2Controller($state, AuthServerProvider, $stateParams, Article, StoreWorkEditConfig, Product, Editors,$localStorage, OrderArticle) {

        // {storeId}/{pid}/{vid}/{aid}
        $(".navbar").hide();
        $(".wrap").hide();
        var storeId = $stateParams.storeId;
        var pid = $stateParams.pid;
        var vid = $stateParams.vid;
        var aid = $stateParams.aid;
        var orderArticleId = $stateParams.orderArticleId;
        localStorage.removeItem('variableData');
        var variableData = $stateParams.variableData;
        if(variableData){
            localStorage.setItem('variableData', variableData);
        }
        localStorage.setItem('themeFlag', 'two');
        //清除即时保存数据
        localStorage.removeItem('save-article');
        console.log($stateParams)

        //对escape()编码的字符串进行解码
        function getQueryString(name) {
            var reg = new RegExp("(^|)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.href.match(reg);
            if(r != null){
                return window.decodeURIComponent(r[2]);
            }
            return null;//如果此处只写return;则返回的是undefined
        };
        var str = getQueryString("returnurl");
        var str1 = getQueryString("returnurl1");
        var str2 = getQueryString("returnurl2");
        var saveUserName = getQueryString("saveUserName");
        var returnurl2Text = getQueryString("returnurl2Text");
        var source = getQueryString("source");
        console.log(returnurl2Text)
        if(str){
            localStorage.setItem('returnurl', str);
        }else{
            localStorage.removeItem('returnurl')
        }
        if(str1){
            localStorage.setItem('returnurl1',str1);
        }else {
            localStorage.removeItem('returnurl1')
        }

        if(str2){
            localStorage.setItem('returnurl2', str2);
        }else {
            localStorage.removeItem('returnurl2')
        }
        if(saveUserName){
            localStorage.setItem('saveUserName', saveUserName);
        }else {
            localStorage.removeItem('saveUserName')
        }
        if(returnurl2Text){
            localStorage.setItem('returnurl2Text', returnurl2Text);
        }else {
            localStorage.removeItem('returnurl2Text')
        }
        if(source){
            localStorage.setItem('source', source);
        }else {
            localStorage.removeItem('source')
        }
        function isMobile(){
            var ua = window.navigator.userAgent;
            var isWeChat = ua.match(/MicroMessenger/i);
            if(isWeChat){
                // 检测是否为 PC 微信小程序环境（PC 小程序特有标识）
                if (/MiniProgramEnv\/Windows|MiniProgramEnv\/Mac/i.test(ua)) {
                     return true; // 这就是PC 小程序 WebView
                 }
                 // PC微信内置浏览器（打开普通链接）
                 if (/WindowsWechat|MacWechat/i.test(ua)) {
                     return false;
                 }
                 // 手机端微信
                 return true;
             }
            if(ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|Harmony)/i)) {
                return true;
            }else{
                return false;
            }
        }
        var isMobile = isMobile();
        // return

        if ($stateParams.auth) {
            AuthServerProvider.storeAuthenticationToken($stateParams.auth, true);
            init();
        }
        else if ($stateParams.ticket) {
            var token = getToken($stateParams.ticket, function(token) {
                if (token) {
                    AuthServerProvider.storeAuthenticationToken(token, true);
                    init();
                } else {
                    // illegal
                    console.error("Cannot open article with failure of getToken");
                }
            });
        } else {
            // illegal
            console.error("Cannot open article with nothing ticket or auth");
        }

        function getToken(ticket, callback) {
            Article.getToken({ticket: ticket}, function (res) {
                if (res.status == 200) {
                    var token = res.data;
                    if (token && callback) {
                        callback(token);
                    } else {
                        console.log("Invalid token or callback, token=" + token);
                    }
                } else {
                    console.log("Error to getToken with ticket: " + ticket + ", article=" + aid);
                }
            });
        }

        function init() {
            debugger
            if (orderArticleId) {
                OrderArticle.get({id: orderArticleId},function(res){
                    var data = res.data;
                    document.title = data.productName;
                    if (!isMobile) {
                        // pc browser
                        if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                            $state.go('editorPhotoWebEdit1', {storeId: storeId, orderArticleId: orderArticleId},{location: 'replace'})
                        }
                        else {
                            $state.go('editorPhotoAlbumEdit1', {storeId: storeId, orderArticleId: orderArticleId},{location: 'replace'})
                        }
                    }
                    else {
                        // mobile device
                        $state.go('404',{storeId:vm.storeId,tips:"不支持的接口调用"},{location: 'replace'});
                    }
                })
            }
            else if (aid) {
                Article.get({id: aid},function (res) {
                    if(res.status==200){
                        $localStorage.article = res.data;
                        document.title = res.data.productName;
                        if(res.data.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:storeId},{location: 'replace'});
                            return
                        }
                        Product.get({id: pid}, function (res1) {
                            var product = res1.data;
                            var data = res.data;
                            //进入新建页面
                            if (data.articleStatus=='NEW'){
                                StoreWorkEditConfig.storeId(function (msg) {
                                    if (msg.status == 200) {
                                        // sku
                                        if(msg.data.level == 'ItemValue'){
                                            selectXml(data);
                                        }else{
                                            // 模板行
                                            if(!isMobile){
                                                if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                                                    $state.go("editorPhotoBothWeb", {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'});
                                                }else{
                                                    $state.go("editorPhotoAlbum", {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'});
                                                }
                                            }else{
                                                localStorage.setItem("Production", "start");
                                                localStorage.removeItem("pages");
                                                localStorage.removeItem("article-count");
                                                localStorage.removeItem("work-save");
                                                if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                                                    $state.go("editorPhotoBoth", {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{reload: true,location: 'replace'});
                                                    return
                                                }
                                                if (data.editorType == 'BOOK_JUNIOR') {
                                                    $state.go('product-choose-ec', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                } else if (data.editorType == null || data.editorType == "" || data.editorType == 'BOOK_SENIOR') {
                                                    $state.go('product-chooseNew-ec', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                } else if (data.editorType == 'NEW_EDITOR'||data.editorType == 'CALENDAR_EDITOR') {
                                                    $state.go('editorPhotoAlbumM', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                } else if (data.editorType == "FORM_EDITOR") {
                                                    $state.go('editorForm', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                } else if (data.editorType == "PHOTO_EDITOR") {
                                                    $state.go('idPhoto', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                }else{
                                                    $state.go('product-chooseThree-ec', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                }
                                            }
                                        }
                                    }
                                })
                            }else{
                                // 进入编辑页面
                                if(!isMobile){
                                    if(data.editorType=='PICTURE' || data.editorType=='PICTURE_PRO' || data.editorType=='PICTURE_PRO_P'){
                                        $state.go("editorPhotoBothWebEdit",{storeId:storeId,aid:aid},{location: 'replace'})
                                    }else{
                                        $state.go('editorPhotoAlbumEdit', {storeId:storeId,aid:aid},{location: 'replace'})
                                    }
                                }else{
                                    localStorage.setItem("Production", "view");
                                    if (data.editorType == 'BOOK_JUNIOR') {
                                        $state.go('editorPhotoAlbumEditM', {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    } else if (data.editorType == "PHOTO_EDITOR") {
                                        $state.go("idPhotoEdit", {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    }  else if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                                        $state.go("editorPhotoBothEdit", {storeId: storeId, aid: aid},{reload: true,location: 'replace'});
                                    } else if (data.editorType == null || data.editorType == "" || data.editorType == 'BOOK_SENIOR') {
                                        $state.go('editorPhotoAlbumEditM', {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    } else if (data.editorType == 'NEW_EDITOR'||data.editorType == 'CALENDAR_EDITOR') {
                                        $state.go('editorPhotoAlbumEditM', {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    }else{
                                        $state.go('product-choosesThree-ec', {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    }
                                }
                            }
                        })
                    }
                })
            }
        }



        function selectXml(data) {
            //web 端
            Product.get({id: pid}, function (res) {
                if(!isMobile){
                    Editors.navigateSelect(storeId, {pid:pid, vid:vid, aid:aid, mobile: isMobile, selectState: 'commoditySelect'})
                }else{
                    Editors.navigateSelect(storeId, {pid:pid, vid:vid, aid:aid, mobile: isMobile, selectState: 'thumbnail'})
                }
            })
        }
    }
})();
